import React from "react";
import { connect } from "react-redux";
import { signinActions } from "../../../actions";
import { mutedClick, emptyFunction } from "../../design/utilities";
import LoginForm from "../../design/onboarding/LoginForm";

class ConnectedLoginForm extends React.Component {
  getSubmitParams = () => {
    const {
      emailValue: email,
      passwordValue: password,
      callback,
      callbackType,
      per_page,
      episode_id
    } = this.props;

    let callbackArgs;
    if (!this.props.callbackArgs) {
      callbackArgs = [{ page_number: 1, per_page, episode_id }];
    } else {
      callbackArgs = [
        { page_number: 1, per_page, episode_id },
        ...this.props.callbackArgs
      ];
    }
    return {
      credentials: { email, password },
      callback,
      callbackType,
      callbackArgs
    };
  };

  onKeyUp = event => {
    if (event.key === "Enter") {
      this.submitForm(event);
    }
  };

  submitForm = event => {
    mutedClick(event);
    this.props.submitSignin(this.getSubmitParams());
  };

  render() {
    return (
      <LoginForm
        emailValue={this.props.emailValue}
        errorMsg={this.props.errorMsg}
        handleEmailChange={this.props.handleEmailChange}
        handlePasswordChange={this.props.handlePasswordChange}
        onKeyUp={this.onKeyUp}
        onLoginClick={this.submitForm}
        onPasswordForgottenClick={this.props.onPasswordForgottenClick}
        passwordValue={this.props.passwordValue}
        passwordForgottenPath={this.props.passwordForgottenPath}
        t={this.props.t}
      />
    );
  }
}

const mapState = state => ({
  callback: state.signin.callback,
  callbackType: state.signin.callbackType,
  callbackArgs: state.signin.callbackArgs,
  per_page: state.current_episode_comments.length || "",
  emailValue: state.signin.email,
  errorMsg: state.signin.errorMsg,
  episode_id: state.currentEpisode.id,
  passwordValue: state.signin.password,
  passwordForgottenPath: LanguageManager.langPath("password_forgotten"),
  t: I18n.t("components.signInModal")
});

const mapDispatch = (dispatch, ownProps) => ({
  handleEmailChange: event => {
    dispatch(signinActions.setEmail(event.target.value));
  },
  handlePasswordChange: event => {
    dispatch(signinActions.setPassword(event.target.value));
  },
  submitSignin: ({ credentials, callback, callbackType, callbackArgs }) => {
    dispatch(
      signinActions.handleMailSignin(
        credentials,
        callback,
        callbackType,
        callbackArgs
      )
    );
  },
  onPasswordForgottenClick: emptyFunction
});

export default connect(mapState, mapDispatch)(ConnectedLoginForm);
